import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ExamState = {
  exam: { id: string; title: string; shortDescription: string } | null;
  loading: boolean;
  error: string | null;
};

const initialState: ExamState = {
  exam: null,
  loading: false,
  error: null,
};

const examSlice = createSlice({
  name: "exam",
  initialState,
  reducers: {
    fetchExamRequest: (state, action: PayloadAction<{ title: string; description?: string }>) => {
      state.loading = true;
      state.error = null;
    },
    fetchExamSuccess: (state, action: PayloadAction<any>) => {
      state.exam = action.payload;
      state.loading = false;
    },
    fetchExamFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    addExamRequest: (state, action: PayloadAction<{ title: string; description?: string }>) => {
      state.loading = true;
      state.error = null;
    },
    addExamSuccess: (state, action: PayloadAction<any>) => {
      state.exam = action.payload;
      state.loading = false;
    },
    addExamFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateExamRequest: (
        state,
        action: PayloadAction<{ examId: string; title?: string; description?: string }>
    ) => {
      state.loading = true;
    },
    updateExamSuccess: (state, action: PayloadAction<{ id: string; title: string; shortDescription: string }>) => {
      if (state.exam?.id === action.payload.id) {
        state.exam = action.payload;
      }
      state.loading = false;
    },
    updateExamFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetExam(state) {
      state.exam = { id: "", title: "", shortDescription: "" };
    },
  },
});

export const {
  updateExamRequest,
  updateExamSuccess,
  updateExamFailure,
  addExamRequest,
  addExamSuccess,
  addExamFailure,
  fetchExamRequest,
  fetchExamSuccess,
  fetchExamFailure,
  resetExam
} = examSlice.actions;
export default examSlice.reducer;
